import React, { FunctionComponent, useEffect, useRef } from 'react';

import { animate } from 'framer-motion';

export type AnimateNumberFomat =
  | 'money'
  | 'short'
  | 'percentage'
  | 'none'
  | 'analytics';

interface AnimateNumberProps {
  className?: string;
  from: number;
  to: number;
  format?: AnimateNumberFomat;
  noAnimation?: boolean;
}

const moneyFormatter = Intl.NumberFormat('en-us', {
  //@ts-ignore
  notation: 'compact',
  compactDisplay: 'short',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const normalFormatter = Intl.NumberFormat('en-us', {});

const AnimateNumber: FunctionComponent<AnimateNumberProps> = ({
  className,
  from,
  to,
  format,
  noAnimation,
}) => {
  const ref = useRef() as React.MutableRefObject<HTMLParagraphElement>;

  useEffect(() => {
    const controls = animate(from, to, {
      duration: noAnimation ? 0 : 0.6,
      ease: [0.0, 0.0, 0.25, 1.0],
      onUpdate(value) {
        if (format === 'money') {
          ref.current.textContent = `$${moneyFormatter.format(value)}`;
        } else if (format === 'short') {
          ref.current.textContent = moneyFormatter.format(value);
        } else if (format === 'percentage') {
          ref.current.textContent = `${value.toFixed()}%`;
        } else if (format === 'none') {
          ref.current.textContent = normalFormatter.format(value);
        } else if (format === 'analytics') {
          ref.current.textContent = `${
            value !== 0
              ? moneyFormatter.format(value)
              : normalFormatter.format(value)
          }`;
        } else {
          ref.current.textContent = value.toFixed();
        }
      },
    });

    return () => controls.stop();
  }, [to, format, from, noAnimation, ref]);

  return <span className={className || ''} ref={ref} style={{ margin: 0 }} />;
};

export default AnimateNumber;
